import React from 'react';
import { Typography, Grid, Container, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MortgageSummary from './MortgageSummary';
import SEOHead from '../../SEO/SEOHead';

const MortgageCalculator = () => {
  const { i18n } = useTranslation();
  const lng = i18n.language || 'es';

  return (
    <>
      <SEOHead
        title="Calculadora de Hipotecas en Canadá"
        description="Calcula tus pagos mensuales de hipoteca, costos de interés y seguro CMHC. Herramienta gratuita para compradores en Canadá."
        canonical="/calculadora-hipoteca"
      />
      <Container maxWidth="lg" sx={{ pt: 5, pb: 6 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              gutterBottom
              align="center"
              sx={{ fontWeight: 600, color: '#1A1A1A' }}
            >
              Calculadora de hipotecas
            </Typography>
            <Typography
              variant="h6"
              gutterBottom
              align="center"
              sx={{ color: '#5F6B7A', maxWidth: 700, mx: 'auto', mb: 4 }}
            >
              Estima tus pagos de hipoteca, costos totales de intereses y tarifas de seguro hipotecario CMHC en Canadá.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <MortgageSummary />
          </Grid>


          {/* CMHC Educational Box */}
          <Grid item xs={12} sx={{ mb: 16 }}>
            <Box
              sx={{
                bgcolor: '#FFFFFF',
                border: '1px solid #E6E9EE',
                borderRadius: '16px',
                p: { xs: '24px', md: '28px' },
                mt: 2,
              }}
            >
              <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#1A1A1A', mb: 2 }}>
                ¿Qué es el seguro CMHC?
              </Typography>
              <Typography sx={{ fontSize: '14px', color: '#1A1A1A', mb: 3, lineHeight: 1.7 }}>
                Si tu enganche es menor al 20% del precio de la vivienda, necesitarás un seguro hipotecario (CMHC).
                Este seguro protege al prestamista, pero el costo lo paga el comprador. La prima se agrega al monto
                de tu hipoteca y varía según el porcentaje de tu enganche: del 4.0% (enganche del 5%) al 2.8%
                (enganche del 15-19.99%).
              </Typography>
              <Typography
                component={RouterLink}
                to={`/${lng}/financlopedia/cmhc`}
                sx={{
                  fontSize: '14px',
                  color: '#1E3A5F',
                  fontWeight: 600,
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Aprende más sobre el seguro CMHC →
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default MortgageCalculator;
